'use strict';

var Utils = require('../../utils/utils');

var Collapse = function($item, $button, $collapse, $collapseInner) {

  var self = this;
  var $document = $(document);

  self.parseItems = function() {

    $item.each(function() {
      var $this = $(this);
      var _$button = $this.find($button);
      var _$collapse = $this.find($collapse);
      var _$collapseInner = $this.find($collapseInner);

      if (_$collapse.length) {
        self.setEventId(_$button, _$collapse, _$collapseInner);
      }
    });
  }

  self.setEventId = function(_$button, _$collapse, _$collapseInner) {
    var eventId = new Utils().randomId();
    _$button.attr('data-event-id', eventId);
    self.clickHandler(_$button, eventId, _$collapse, _$collapseInner);
  }

  self.clickHandler = function(_$button, eventId, _$collapse, _$collapseInner) {

    _$button.on('click.filterCollapse' + eventId, new Utils().throttle(function() {
      self.collapseVisibility(_$button, _$collapse, _$collapseInner);
    }, 300));

    $document.on('click.filterCollapse' + eventId, function(e) {
      if (!$(e.target).closest(_$collapse).length && !$(e.target).closest('.filters__calendar-prev, .filters__calendar-next').length && !$(e.target).closest(_$button).length) {
        if (_$collapse.hasClass('is-visible')) {
          self.hideCollapse(_$button, _$collapse, _$collapseInner);
        }
      }
    });
  }

  self.collapseVisibility = function(_$button, _$collapse, _$collapseInner) {

    if (_$collapse.hasClass('is-visible') && !_$collapse.hasClass('velocity-animating')) {
      self.hideCollapse(_$button, _$collapse, _$collapseInner);
    } else if (!_$collapse.hasClass('velocity-animating')) {
      self.showCollapse(_$button, _$collapse, _$collapseInner);
    }
  }

  self.showCollapse = function(_$button, _$collapse, _$collapseInner) {

    var delay = 0;

    if ($('.filters__dropdown').hasClass('is-visible') || $('.filters__calendar').hasClass('is-visible')) {
      delay = 400;
    }

    _$button.addClass('is-active');
    _$collapse.addClass('is-visible');
    _$collapse.velocity(
      'slideDown',
      {
        easing: 'easeOutQuart',
        duration: 300,
        delay: delay,
        complete: function() {
          _$collapseInner.velocity(
            {
              opacity: 1
            },
            {
              duration: 180
            }
          );

          var _$input = _$collapse.find('input');

          if (_$input.length) {
            _$input.focus();
          }
        }
      }
    );
  }

  self.hideCollapse = function(_$button, _$collapse, _$collapseInner) {

    _$button.removeClass('is-active');
    _$collapse.removeClass('is-visible');
    _$collapseInner.velocity(
      {
        opacity: 0
      },
      {
        duration: 210,
        complete: function() {

          _$collapse.velocity(
            'slideUp',
            {
              easing: 'easeOutQuart',
              duration: 190
            }
          );
        }
      }
    );
  }

  self.reset = function() {

    $button.each(function() {
      var $this = $(this);

      if ($this[0].hasAttribute('data-event-id')) {

        var eventId = $this.attr('data-event-id');

        $document.off('click.filterCollapse' + eventId);

        $this
          .off('click.filterCollapse' + eventId)
          .removeClass('is-active');
      }
    });

    $collapse
      .removeClass('is-visible')
      .removeAttr('style');

    $collapseInner.removeAttr('style');
  }

  self.init = function() {
    self.parseItems();
  }
};

module.exports = Collapse;
